module.exports = __webpack_public_path__ + "static/media/logo-KT-color.a1d2033b.png";